<script setup>
import {defineModel} from "vue";
import {useI18n} from "vue-i18n";

const { t } = useI18n()
const model = defineModel();
</script>
<template>
    <v-switch
        v-model="model"
        color="green"
        inset
        hide-details
        :label="modelValue ? t('common.labels.active') : t('common.labels.inactive')"
        class="text-black"
    />
</template>
